import React, { useCallback, useContext, useMemo } from 'react';

import { DeviceList } from 'app/home/main-pages/devices/Devices'
import { BindActionType, checkAndTransformDeviceForBind } from 'app/model/Bind';
import { LocalizationContext, useLocalizedStrings } from 'app/localization/Context';
import { createBindScenarioInfoObject } from 'app/model/BindData';
import { DeviceType } from 'app/model/Device';
import { ScenarioList } from 'app/home/main-pages/scenarios/Scenarios';

import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconBack } from 'images/general/back.svg';


export default function SelectDevice({
    negotiatedProtocol,
    devices, dismissHandler,
    pageData, setPageData, back }) {
    const s = useLocalizedStrings();
    const b = s.createBindProcess;

    const selectionCallback = useCallback((device) => {
        if ([DeviceType.sedna, DeviceType.hinavaEcoThermostat].includes(device.type)) {
            setPageData({ name: 'thermostat-special', stage: pageData.stage, device });
        } else if ([DeviceType.tvRemote, DeviceType.splitRemote].includes(device.type)) {
            setPageData({ name: 'remote-special', stage: pageData.stage, device });
        } else if ((device.type === DeviceType.evaporativeCooler) && (pageData.stage === "then")) {
            setPageData({ name: 'remote-special', stage: pageData.stage, device });
        } else {
            setPageData({ name: 'select-action', stage: pageData.stage, device });
        }
    }, [pageData, setPageData]);

    const devicesForList = useMemo(() => {
        let _devicesForList = [];
        for (let i = 0; i < devices.length; i++) {
            const device = devices[i];
            const _device = checkAndTransformDeviceForBind(negotiatedProtocol, pageData.stage, device);
            if (_device) {
                _devicesForList.push(_device);
            }
        }
        return _devicesForList;
    }, [pageData, devices, negotiatedProtocol]);

    return (
        <div className="create-bind-page-content">
            <IconBack className="nav-icon" /> <div className="nav-button" onClick={() => { back(); }} />
            <IconX className="nav-icon-secondary" /> <div className="nav-button-secondary" onClick={dismissHandler} />

            <div className="header" style={{ marginBottom: "16px" }}>{b.selectDevice}</div>

            <DeviceList
                devices={devicesForList}
                selectionCallback={selectionCallback}
                showStates={false}
                dontOpenSettings={true}
                showSubDevices={true} />
        </div>
    );
}

export function SelectScenario({
    preBind, pushState,
    scenarios, dismissHandler, back }) {
    const l = useContext(LocalizationContext);
    const s = useLocalizedStrings();
    const b = s.createBindProcess;

    // const selectionCallback = useCallback((device) => {
    //     if (device.type === DeviceType.sedna) {
    //         setPageData({ name: 'thermostat-special', stage: pageData.stage, device });
    //     } else if ([DeviceType.tvRemote, DeviceType.splitRemote].includes(device.type)) {
    //         setPageData({ name: 'remote-special', stage: pageData.stage, device });
    //     } else if ((device.type === DeviceType.evaporativeCooler) && (pageData.stage === "then")) {
    //         setPageData({ name: 'remote-special', stage: pageData.stage, device });
    //     } else {
    //         setPageData({ name: 'select-action', stage: pageData.stage, device });
    //     }
    // }, [pageData, setPageData]);

    const selectionCallback = useCallback((_scenario) => {
        const _preBind = { ...preBind };
        let _actionInfos = [..._preBind.actionInfos];
        _actionInfos = _actionInfos.filter(info =>
            (info.data.action_type !== BindActionType.scenario) || (info.data.scenario_id !== _scenario.id)
        );
        _actionInfos.push(createBindScenarioInfoObject(l, _scenario.id, _scenario.pic_id, _scenario.name));
        _preBind.actionInfos = _actionInfos;
        pushState({ preBind: _preBind, pageData: { name: 'main' } });
    }, [preBind, pushState, l]);

    return (
        <div className="create-bind-page-content">
            <IconBack className="nav-icon" /> <div className="nav-button" onClick={() => { back(); }} />
            <IconX className="nav-icon-secondary" /> <div className="nav-button-secondary" onClick={dismissHandler} />

            <div className="header" style={{ marginBottom: "16px" }}>{b.selectScenario}</div>

            <ScenarioList
                // bottomPaddingSize={64 + 16 + 8} // +8 for safe-area
                marginTop={0} marginRight={0} marginLeft={0}
                scenarios={scenarios}
                selectionCallback={selectionCallback} />
        </div>
    );
}
